
import Form from "./Form.vue";
import ParcelamentoData from "./ParcelamentoData";
import { mapGetters } from "vuex";
import { onboardStore } from "../../../onboardStore";
import {
  SistemaMixin,
} from "@/modules/Application";

export default {
  name: "app-formaPagamento-create",
  data() {
    return {
      onboardStore,
      parcelamento: new ParcelamentoData({}),
    };
  },
  components: {
    Form,
  },
  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
